module.exports = __webpack_public_path__ + "media/images/servicios-color-db6d684919e20939ecec7709414fb13b.png";